export const deepClone = (src) => JSON.parse(JSON.stringify(src))

export const sleep = (sec) => new Promise((resolve) => setTimeout(resolve, sec * 1000))
